import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface MoveCommand {
  location: {
    id: string;
    name: string;
  };
}

const client = createClient('/rest/operator-api/charging-stations');

export const move: SaveOperation<MoveCommand, void, string> = postRequestFactory<MoveCommand, void, string>(
  client,
  {
    pattern: '/{chargingStationId}/move',
    permissionId: commandPermissions.MOVE_CHARGING_STATION
  }
);
